<template>
  <div>
    <CModal
      color="primary"
      :show.sync="isShowPopup"
      :close-on-backdrop="false"
      size="lg"
      scrollable
    >
      <template #header>
        <h6 class="modal-title">Subscription</h6>
        <CButtonClose @click="modalCallBack(false)" class="text-black" />
      </template>
      <template #footer>
        <CButton
          type="button"
          color="primary"
          variant="outline"
          class="px-4"
          @click="modalCallBack(false)"
          >Cancel</CButton
        >
        <CButton type="button" color="primary" class="px-4" @click="onSubmit"
          >Subscribe</CButton
        >
      </template>
      <div>
        <table
          class="table table-striped table-hover text-center border-bottom mb-0 w-100"
        >
          <thead>
            <tr style="background-color: lightgrey">
              <td style="font-weight: 600" col="md-10">Options</td>
              <td style="font-weight: 600" col="md-2">
                <label class="text-left">{{ subscriptionType }}</label>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(i, index) in subscriptionFields"
              :key="i.subscription_option_id"
              :style="`${
                i.selected
                  ? 'background-color: #D0F0C0'
                  : 'background-color: white'
              }`"
            >
              <td class="align-left text-left" :class="i.default_option ? 'font-weight-bold' : ''">
                {{ i.option_name }}
              </td>
              <td>
                <label class="form-checkbox">
                  <input
                    :id="i.subscription_option_id"
                    :name="i.option_name"
                    type="checkbox"
                    value="1"
                    :checked="i.selected"
                    :disabled="i.default_option"
                    @change="handleChangeCheckBox($event, i, index)"
                  />
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CModal>
  </div>
</template>
<script>
import _ from "lodash";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", { ...required, message: "This field is required" });

export default {
  props: {
    isShowPopup: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      payload: {},
      subscriptionFields: [],
      isSelectedAll: false,
    };
  },
  computed: {
    subscriptionType() {
      return (this.data?.length && this.data[0]?.subscription_name) || "";
    },
    subscriptionFields1() {
      return this.data?.map((v) => ({
        option_name: v.option_name,
        selected: v.selected,
        default_option: v?.default_option,
        subscription_option_id: v?.subscription_option_id,
      })).sort((a, b) => a.default_option - b.default_option);
    },
  },
  methods: {
    handleChangeCheckBox(event, data, index) {
      const { checked, name } = event.target;
      this.subscriptionFields[index].selected = checked
    },
    onSubmit() {
      this.modalCallBack(true);
    },
    modalCallBack(action) {
      let payload = null
      if(action){
        payload = this.subscriptionFields.filter(v=>v.selected)?.map(v=>({subscription_option_id:v.subscription_option_id}))
      }
      this.$emit("modalCallBack", action, payload);
    },
  },
  mounted() {
    this.subscriptionFields = this.data?.map((v) => ({
        option_name: v.option_name,
        selected: v.selected,
        default_option: v?.default_option,
        subscription_option_id: v?.subscription_option_id,
      })).sort((a, b) => b.default_option - a.default_option);
    }
};
</script>
<style lang="scss" scoped>
input[type="checkbox"]:disabled {
  accent-color: #999;
  opacity: 1; /* prevents fading */
  cursor: not-allowed;
}
</style>
